import { useSelector } from "react-redux";

export const useAuth = () => {
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth);
  const { allowedRoutes, allowedRoutesLoading } = useSelector((state) => state.admin);
  const { permissionsFlag, permissionFlagsLoading } = useSelector((state) => state.admin);
  const { savedFilters, savedColumns, status } = useSelector((state) => state.preferences);
  const { oemHistory, historyLoading, histroyError } = useSelector((state) => state.history);

  return {
    isAuthenticated,
    allowedRoutes,
    user,
    allowedRoutesLoading,
    loading,
    permissionsFlag,
    permissionFlagsLoading,
    savedFilters,
    savedColumns,
    status,
    oemHistory,
    historyLoading,
    histroyError
  };
};
